import React, { useEffect, useRef, useState } from 'react';
import { Container } from 'react-bootstrap';
import { isEmpty } from 'lodash';
import { useTranslation } from 'react-i18next';
import { shortenandHoverString } from '../../Components/helper';

let breaks = [];
let timerId = 0;
function TabMenu(props) {
  const { t } = useTranslation('common');
  const { activeTheTab, masterActiveTab, loader, tableLoading, MenuList, bulkUpdate } = props;
  const navRef = useRef(null);
  const btnRef = useRef(null);

  const vlinksRef = useRef(null);
  const hlinksRef = useRef(null);
  const [activeUnderline, setActiveUnderline] = useState({});
  const updateNav = () => {
    timerId = setTimeout(() => {
      const nav = navRef.current;
      const btn = btnRef.current;
      const vlinks = vlinksRef.current;
      const hlinks = hlinksRef.current;
      if (nav && btn && vlinks && hlinks) {
        const availableSpace = btn.classList.contains('hidden') ? nav.clientWidth : nav.clientWidth - btn.clientWidth - 30;

        if (vlinks.clientWidth > availableSpace) {
          if (vlinks.lastChild) {
            breaks.push(vlinks.clientWidth);
            hlinks.prepend(vlinks.lastChild);
          }

          if (btn.classList.contains('hidden')) {
            btn.classList.remove('hidden');
          }
        } else {
          if (availableSpace > breaks[breaks.length - 1] && !isEmpty(hlinks) && !isEmpty(vlinks) && hlinks.lastChild) {
            vlinks.append(hlinks.firstChild);
            breaks.pop();
          }
          if (breaks.length < 1) {
            btn.classList.add('hidden');
            hlinks.classList.add('hidden');
          }
        }
        btn.setAttribute('count', breaks.length);

        if (vlinks.clientWidth > availableSpace) {
          updateNav();
        }
      }
    }, 300);
  };
  useEffect(() => {
    if (vlinksRef.current && masterActiveTab && MenuList?.length > 0) {
      const activeTab = vlinksRef.current.querySelector('.active');

      if (activeTab) {
        const tabRect = activeTab?.getBoundingClientRect();
        const parentRect = vlinksRef?.current?.getBoundingClientRect();

        setActiveUnderline({
          width: tabRect.width,
          left: tabRect.left - parentRect.left,
        });
      } else {
        setActiveUnderline({
          width: 0,
          display: 'none',
        });
      }
    }
  }, [masterActiveTab, MenuList]);

  const toggleHidden = () => {
    const hlinks = hlinksRef.current;
    if (hlinks) {
      hlinks.classList.toggle('hidden');
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (!loader) {
        updateNav();
      }
    };

    const handleWindowResize = () => {
      clearTimeout(timerId);
      timerId = setTimeout(handleResize, 300);
    };

    if (!loader) {
      updateNav();
      window.addEventListener('resize', handleWindowResize);
    }

    return () => {
      clearTimeout(timerId);
      window.removeEventListener('resize', handleWindowResize);
    };
  }, [MenuList?.length, loader]);

  useEffect(() => {
    return () => {
      breaks = [];
    };
  }, []);
  return (
    Array.isArray(MenuList) &&
    MenuList?.length > 0 && (
      <Container fluid className="p-0 mb-2">
        <div className="new-tab-conatiner">
          <div className="new-tab-list">
            <div className="tab-container">
              <nav className="greedy-nav" ref={navRef}>
                <ul className="subnav-ul visible-links" ref={vlinksRef}>
                  {MenuList?.length > 0 &&
                    MenuList?.map((element) => {
                      return (
                        <li key={element?._id}>
                          <button
                            type="button"
                            className={masterActiveTab === element._id ? 'active' : ''}
                            disabled={element?.isDisabled || loader || bulkUpdate || tableLoading}
                            onClick={() => activeTheTab(element?._id)}
                          >
                            <div className="tab-item">
                              <span className="d-flex text-bold ml-0 align-items-center">{shortenandHoverString(element?.name, 20, 'auto')}</span>
                            </div>
                          </button>
                        </li>
                      );
                    })}
                </ul>
                <button
                  type="button"
                  className="btn-more-dropdown"
                  aria-label={t('COMMON_LABEL.BACK')}
                  onClick={toggleHidden}
                  ref={btnRef}
                  disabled={bulkUpdate}
                >
                  <span className="icon-More f-32 text-black" />
                </button>
                <ul className="hidden-links hidden" ref={hlinksRef} />
                <div className="tab-underline" style={activeUnderline} />
              </nav>
            </div>
          </div>
        </div>
      </Container>
    )
  );
}

export default TabMenu;
